import { toConsumableArray as _toConsumableArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import format from '../../../node_modules/date-fns/esm/format/index.js';
import { values, groupBy, flatMap } from 'lodash-es';
import { COUPON_TYPE_OPTIONS } from '../type.js';
import startOfDay from '../../../node_modules/date-fns/esm/startOfDay/index.js';
import endOfDay from '../../../node_modules/date-fns/esm/endOfDay/index.js';
import differenceInSeconds from '../../../node_modules/date-fns/esm/differenceInSeconds/index.js';

var INVALID_MESSAGE = {
  NOT_FOUND: '등록 불가한 쿠폰이 있습니다',
  NOT_DOWNLOAD_TYPE: '적용할 수 없는 쿠폰입니다 - 다운로드/첫구매/비공개만 가능',
  DURATION_NOT_START: '쿠폰의 발행시작일이 도래하지 않은 쿠폰이 있습니다.',
  DURATION_END: '기간이 만료된 쿠폰이 있습니다.',
  INVALID_START_AT: '쿠폰의 발행 시작일이 기획전 시작일보다 느린 쿠폰이 있습니다.',
  INVALID_END_AT: '기획전 종료일 보다 발행/발급 종료일이 빠르게 설정된 쿠폰이 있습니다.',
  UNABLE_PUBLISH: '발행이 중단/중지된 쿠폰입니다.'
};
function dateFormat(date, type) {
  if (typeof date === 'string') {
    return format(new Date(date), type);
  }
  return format(date, type);
}
function getInvalidMessage(_ref) {
  var publishType = _ref.publishType,
    publishState = _ref.publishState,
    autoPublish = _ref.autoPublish,
    startAt = _ref.startAt,
    endAt = _ref.endAt,
    exhibitionInfo = _ref.exhibitionInfo;
  var durationStartDiff = startAt ? differenceInSeconds(new Date(), startAt) : undefined;
  var durationEndDiff = endAt ? differenceInSeconds(endAt, new Date()) : undefined;
  var publishStartDiff = exhibitionInfo !== null && exhibitionInfo !== void 0 && exhibitionInfo.startAt && startAt ? differenceInSeconds(new Date(exhibitionInfo.startAt), new Date(startAt)) : undefined;
  var publishEndDiff = exhibitionInfo !== null && exhibitionInfo !== void 0 && exhibitionInfo.endAt && endAt ? differenceInSeconds(new Date(endAt), new Date(exhibitionInfo === null || exhibitionInfo === void 0 ? void 0 : exhibitionInfo.endAt)) : undefined;
  var isError;
  var errorType;
  switch (true) {
    // 다운로드/첫구매/비공개만 가능
    case !(publishType === 'DOWNLOAD' || publishType === 'FIRST_ORDER' || publishType === 'HIDDEN' && !autoPublish):
      errorType = 'NOT_DOWNLOAD_TYPE';
      isError = true;
      break;
    // now() < 발행/발급 시작일인 경우
    case durationStartDiff && durationStartDiff < 0:
      errorType = 'DURATION_NOT_START';
      isError = false;
      break;
    // now() > 발행/발급 종료일인 경우
    case durationEndDiff && durationEndDiff < 0:
      errorType = 'DURATION_END';
      isError = true;
      break;
    // 기획전 시작일 < 상품/장바구니 쿠폰 발행시작일인 경우
    case publishStartDiff && publishStartDiff < 0:
      errorType = 'INVALID_START_AT';
      isError = false;
      break;
    // 기획전 종료일 > 쿠폰 발행/발급 종료일인 경우
    case publishEndDiff && publishEndDiff < 0:
      errorType = 'INVALID_END_AT';
      isError = false;
      break;
    case publishState && publishState !== 'PUBLISHABLE':
      errorType = 'UNABLE_PUBLISH';
      isError = true;
      break;
  }
  return {
    isError: isError,
    errorType: errorType
  };
}
function getGroupedErrorType(couponMolds) {
  var groupedInvalidCouponMolds = couponMolds.filter(function (_ref2) {
    var errorType = _ref2.errorType;
    return errorType;
  }).reduce(function (acc, obj) {
    var _obj$errorType = obj.errorType,
      errorType = _obj$errorType === void 0 ? 'DURATION_END' : _obj$errorType;
    if (acc[errorType]) {
      acc[errorType].push(obj);
    } else {
      acc[errorType] = [obj];
    }
    return acc;
  }, {});
  return flatMap(Object.values(groupedInvalidCouponMolds));
}
function getInvalidCouponMolds(couponMolds, exhibitionInfo) {
  var invalidCoupons = couponMolds.map(function (couponMold) {
    var _COUPON_TYPE_OPTIONS$;
    var id = couponMold.id,
      title = couponMold.title,
      publishType = couponMold.type,
      publishStartAt = couponMold.publishStartAt,
      publishEndAt = couponMold.publishEndAt,
      autoPublish = couponMold.autoPublish;
    var startAtWithTime = publishStartAt ? startOfDay(new Date(publishStartAt)) : undefined;
    var endAtWithTime = publishEndAt ? endOfDay(new Date(publishEndAt)) : undefined;
    var message;
    var _getInvalidMessage = getInvalidMessage({
        publishType: publishType,
        autoPublish: autoPublish,
        startAt: startAtWithTime,
        endAt: endAtWithTime,
        exhibitionInfo: exhibitionInfo
      }),
      errorType = _getInvalidMessage.errorType,
      isError = _getInvalidMessage.isError;
    switch (errorType) {
      case 'NOT_DOWNLOAD_TYPE':
        message = "".concat(id, " - ").concat((_COUPON_TYPE_OPTIONS$ = COUPON_TYPE_OPTIONS.find(function (_ref3) {
          var value = _ref3.value;
          return value === publishType;
        })) === null || _COUPON_TYPE_OPTIONS$ === void 0 ? void 0 : _COUPON_TYPE_OPTIONS$.label);
        break;
      case 'INVALID_START_AT':
        message = "".concat(id, " ").concat(title, " - ").concat(publishStartAt ? dateFormat(publishStartAt, 'MM/dd') : '', " \uBC1C\uD589 \uC2DC\uC791");
        break;
      case 'DURATION_NOT_START':
        message = "".concat(id, " ").concat(title, " - ").concat(publishStartAt ? dateFormat(publishStartAt, 'MM/dd') : '', " \uBC1C\uD589 \uC2DC\uC791");
        break;
      case 'DURATION_END':
        message = "".concat(id, " ").concat(title, " - \uAE30\uAC04 \uC885\uB8CC");
        break;
      case 'INVALID_END_AT':
        message = "".concat(id, " ").concat(title, " - ").concat(publishEndAt ? dateFormat(publishEndAt, 'MM/dd') : '', " \uBC1C\uD589 \uC885\uB8CC");
        break;
    }
    return {
      id: id,
      errorType: errorType,
      message: message && "\uC7A5\uBC14\uAD6C\uB2C8 \uCFE0\uD3F0 : ".concat(message),
      isError: isError
    };
  });
  return getGroupedErrorType(invalidCoupons);
}
function getInvalidProductCouponMolds(couponMolds, exhibitionInfo) {
  var invalidCoupons = couponMolds.map(function (couponMold) {
    var id = couponMold.couponMoldId,
      couponName = couponMold.couponName,
      publishType = couponMold.publishType,
      publishState = couponMold.publishState,
      publishStartDate = couponMold.publishStartDate,
      publishEndDate = couponMold.publishEndDate;
    var message;
    var startAt = publishStartDate ? new Date(publishStartDate) : undefined;
    var endAt = publishEndDate ? new Date(publishEndDate) : undefined;
    var _getInvalidMessage2 = getInvalidMessage({
        publishType: publishType,
        publishState: publishState,
        startAt: startAt,
        endAt: endAt,
        exhibitionInfo: exhibitionInfo
      }),
      errorType = _getInvalidMessage2.errorType,
      isError = _getInvalidMessage2.isError;
    switch (errorType) {
      case 'NOT_DOWNLOAD_TYPE':
        // 현재는 publishType에 DOWNLOAD만 존재
        message = "".concat(id, " - \uB2E4\uC6B4\uB85C\uB4DC\uD615\uC774 \uC544\uB2D9\uB2C8\uB2E4.");
        break;
      case 'INVALID_START_AT':
        message = "".concat(id, " ").concat(couponName, " - ").concat(startAt ? dateFormat(startAt, 'MM/dd HH:mm') : '', " \uBC1C\uD589 \uC2DC\uC791");
        break;
      case 'DURATION_NOT_START':
        message = "".concat(id, " ").concat(couponName, " - ").concat(startAt ? dateFormat(startAt, 'MM/dd HH:mm') : '', " \uBC1C\uD589 \uC2DC\uC791");
        break;
      case 'DURATION_END':
        message = "".concat(id, " ").concat(couponName, " - \uAE30\uAC04 \uC885\uB8CC");
        break;
      case 'INVALID_END_AT':
        message = "".concat(id, " ").concat(couponName, " - ").concat(endAt ? dateFormat(endAt, 'MM/dd HH:mm') : '', " \uBC1C\uD589 \uC885\uB8CC");
        break;
      case 'UNABLE_PUBLISH':
        message = "".concat(id, " ").concat(couponName, " - \uBC1C\uD589\uC911\uC9C0\uB41C \uCFE0\uD3F0\uC785\uB2C8\uB2E4.");
        break;
    }
    return {
      id: id,
      errorType: errorType,
      message: message && "\uC0C1\uD488 \uCFE0\uD3F0 : ".concat(message),
      isError: isError
    };
  });
  return getGroupedErrorType(invalidCoupons);
}
function getGroupedCouponMolds(groupedInvalidCartMolds, groupedInvalidProductMolds) {
  var mergedArray = [].concat(_toConsumableArray(groupedInvalidCartMolds), _toConsumableArray(groupedInvalidProductMolds));
  var groupedArray = values(groupBy(mergedArray, 'errorType'));
  return Object.values(groupedArray);
}

export { INVALID_MESSAGE, getGroupedCouponMolds, getInvalidCouponMolds, getInvalidProductCouponMolds };
//# sourceMappingURL=utils.js.map
